module.exports = __webpack_public_path__ + "img/burst.de0ab92d.svg";